module.exports = __webpack_public_path__ + "media/images/icons/v2/bar-chart-square-02-7ab5891ccce3107bc228eadf67ef059e.svg";